import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Search, ArrowRight } from 'lucide-react';

export default function SearchPage() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/browse?search=${encodeURIComponent(query.trim())}`);
    }
  };

  const popularSearches = ['crochet plushie', 'vinyl stickers', 'digital art', 'resin keyring', 'handmade'];

  return (
    <div className="min-h-[60vh] flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-heading font-extrabold mb-4">Search Products</h1>
          <p className="text-muted-foreground">Find unique handmade goods from neurodivergent creators</p>
        </div>

        <form onSubmit={handleSearch} className="flex gap-2">
          <div className="relative flex-1">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
            <Input
              type="text"
              placeholder="Search for crochet, stickers, art, keyrings..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="pl-12 h-14 text-lg input-brutal"
              autoFocus
              data-testid="search-page-input"
            />
          </div>
          <Button type="submit" className="btn-brutal-primary h-14 px-8" data-testid="search-page-btn">
            Search
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </form>

        <div className="mt-8">
          <p className="text-sm text-muted-foreground mb-3">Popular searches:</p>
          <div className="flex flex-wrap gap-2">
            {popularSearches.map((term) => (
              <button
                key={term}
                onClick={() => navigate(`/browse?search=${encodeURIComponent(term)}`)}
                className="px-4 py-2 rounded-full bg-muted hover:bg-pastel-art/30 transition-colors text-sm font-medium border border-primary/10"
              >
                {term}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
